<div #dropDownContainer>
  <ng-content></ng-content>
</div>
